<template>
    <v-card class="agency-card" :elevation="cardElevation">
        <v-img v-if="source.length > 0"
               :src="source"
               :class="cartBtnClass"
               aspect-ratio="1.7778"
               position="center top"
               cover
               @click="clickToCart"
        >

        </v-img>
        <v-card-text class="agencyCardP" v-html="description">
        </v-card-text>
        <v-card-actions>
            <v-btn small block light color="secondary" @click.stop="clickToCart"
                   :class="cartBtnClass">
                auswählen
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>

    export default {
        name: "AgencyCard",
        data: () => ({
            isInStore: false
        }),
        props: {
            source: String,
            label: String,
            description: String,
            agn: String,
            mode: String
        },
        methods: {
            clickToCart(){
                this.$emit('agencyCardClicked',this.agn);
            }
        },
        computed: {
            cartBtnClass(){
                return (this.isInStore) ? (this.mode +' selected') : (this.mode + ' notSelected');
            },
            cardIcon(){
                return (this.isInStore) ? 'check' : 'add';
            },
            cardElevation(){
                return (this.isInStore) ? '8' : '4';
            },
            cardColor(){
                return (this.isInStore) ? 'blue' : 'white';
            }
        },
    }
</script>

<style lang="stylus" >

    div.agencyCardP p {
        margin-bottom: 0;
    }
    div.selectable.notSelected div.v-image__image--cover {
        -webkit-filter:  grayscale(100%) opacity(100%);
        filter: grayscale(100%) opacity(100%);
    }
    div.v-card.agency-card {
        /* padding-top: 0.5em; */
    }
    div.v-card__title button.v-btn {
        margin: 0;
        width: 2em;
        height: 2em;
    }
    div.v-card__title {
        word-break: break-word;
    }
    div.v-card__title.selectable.selected {
        background-color: #0074c6;
        color: white;
    }
    .v-btn i{
        color: darkblue;
    }
    .v-btn.selected {
        box-shadow: none;
        font-weight: bold;
    }
    .v-btn.selectable.selected .v-icon {
        color #ffffff;
    }
    .v-btn.notSelectable {
        display: none;
    }
    .theme--light.v-sheet .v-card__title.headline{
        color #002ea7;
    }
</style>
